import React from 'react';
import FormObjectStringsCell from './FormObjectStringsCell';
import FormObjectTableCell from './FormObjectTableCell';
import { isFormMultiplesField } from '../../state/state';

const FormObjectListCell = ({ field, item }) => {
  if (isFormMultiplesField(field.validation)) {
    return (<FormObjectStringsCell field={field} item={item} options={field.options} />);
  }
  return (<FormObjectTableCell field={field} item={item} />);
};

export default FormObjectListCell;
